import { Component, OnInit } from '@angular/core';
import {IResponse} from '../../interfaces/iresponse';
import {UtilService} from '../../services/utilService/util.service';
import {UserService} from '../../services/apiCalls/userService/user.service';
import {SuperAdminService} from '../../services/apiCalls/superAdminService/super-admin.service';

@Component({
  selector: 'app-transaction-types',
  templateUrl: './transaction-types.component.html',
  styleUrls: ['./transaction-types.component.css']
})
export class TransactionTypesComponent implements OnInit {
  breadCrumb: any;
  loaders = {
    saving: false
  };
  allTransTypes: any [] = [];
  public zones: any[] = [];
  public loadingData = false;
  showData = true;
  constructor(private utilService: UtilService,
              private superAdminService: SuperAdminService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Transaction Types',
      parent: 'Commission',
      subLink: null
    };
    this.getTransactionTypes();
  }
  getTransactionTypes() {
    this.showData = false;
    this.loadingData = true;
    this.superAdminService.getTransactionTypes()
      .subscribe((res: IResponse) => {
        console.log('Response ', res);
        this.allTransTypes = res.data;
        this.utilService.startDatatable('all-transaction-types');
        this.loadingData = false;
        this.showData = true;
      }, error => {
        console.log('Error ', error);
        this.utilService.startDatatable('all-transaction-types');
        this.loadingData = false;
        this.showData = true;
      });
  }

}
